import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ActionDlg } from '../../../../general/dialogs/action-dlg';
import { gotoClientPortal } from '../../../../store/actions/route';
import { authorizeWithOtpSuccess } from '../../reducer/session';

type Props = {
  onClose: () => void;
  context: { hasApplicationInProgress: boolean };
};

const UserWithEmailAndPhoneExistsDlg: FC<Props> = ({ onClose, context }: Props) => {
  const dispatch = useDispatch();
  const { hasApplicationInProgress } = context;

  const { title, content, primaryActionLabel } = hasApplicationInProgress
    ? {
        title: 'Resuming an application?',
        content:
          'It looks like you already have a Coast account. Do you want to resume the application you have in progress for another Coast account?',
        primaryActionLabel: 'Yes, resume application',
      }
    : {
        title: 'You Already Have a Coast Account',
        content: 'It looks like you already have a Coast account. Do you want to apply for another Coast account?',
        primaryActionLabel: 'Yes, apply for a new Coast account',
      };

  const handleContinue = useCallback(() => {
    onClose();
    dispatch(authorizeWithOtpSuccess());
  }, [onClose, dispatch]);

  const handleSignIn = useCallback(() => {
    onClose();
    dispatch(gotoClientPortal());
  }, [onClose, dispatch]);

  return (
    <ActionDlg
      content={content}
      title={title}
      primaryActionLabel={primaryActionLabel}
      secondaryActionLabel="Sign in to existing account"
      onPrimaryAction={handleContinue}
      onSecondaryAction={handleSignIn}
      onClose={onClose}
    />
  );
};

export { UserWithEmailAndPhoneExistsDlg };
